export default __webpack_public_path__ + "static/media/premium.f57b55df.png";